import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LifeBuoy } from "lucide-react";

// Owner-only: shown while an emergency recovery PIN is outstanding.
export default function PinRecoveryBanner() {
  const { user } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const [sec, setSec] = useState(null);
  useEffect(() => {
    if (user?.role !== "owner") return;
    api.get("/auth/security").then((r) => setSec(r.data)).catch(() => {});
  }, [user?.id, user?.role, loc.pathname]);
  if (user?.role !== "owner" || !sec?.pin_recovery_pending || loc.pathname === "/security") return null;
  return (
    <div className="mx-4 mt-3 rounded-xl border border-amber-500/50 bg-amber-500/10 px-4 py-2.5 flex items-center gap-3 text-sm" data-testid="pin-recovery-banner">
      <LifeBuoy className="w-4 h-4 text-amber-600 shrink-0" />
      <p className="flex-1"><b>Recovery PIN issued by NEEC Support.</b> Your previous Owner PIN has been cancelled. Create a new permanent PIN before {sec.pin_recovery_expires_at ? new Date(sec.pin_recovery_expires_at).toLocaleString() : "it expires"}.</p>
      <Button size="sm" className="bg-amber-600 hover:bg-amber-700 text-white" onClick={() => nav("/security")} data-testid="pin-recovery-banner-btn">Complete recovery</Button>
    </div>
  );
}
